import styles from './Toggle.module.scss';

const Toggle = ({ active, action }: { active: boolean; action: () => void }) => (
  <label className={styles.switch}>
    <input checked={active} onChange={action} type="checkbox" />
    <span className={styles.slider}></span>
  </label>
);

export default Toggle;
